module.exports = __webpack_public_path__ + "static/img/我保證300.4e91e35c.png";